import { defineMessages } from 'react-intl';

export const messages: {
	emptyStateMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyStateMessage: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.view.empty-state.empty-state-message',
		defaultMessage: 'No attachments uploaded',
		description: 'Empty state message when no attachments uploaded',
	},
});
